
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard } from "@fortawesome/free-regular-svg-icons";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";

const CongratsIcon = () => (
  <FontAwesomeIcon icon={faAddressCard} style={{ width: "100%", height: "auto" }} />
);


export const OutlineWarningIcon = () => (
  <FontAwesomeIcon icon={faTriangleExclamation} style={{ width: "100%", height: "auto" }} />
);

export const OutlineCircleXIcon = ({ style }: { style?: React.CSSProperties }) => (
  <FontAwesomeIcon icon={faCircleXmark} style={{ width: "100%", height: "auto", ...style }} />
);

export default CongratsIcon;
